import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { menuItems as menuItemsConfig } from '@/router/userMenu';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useUserStore } from '@/store/useUserStore';
import { usePlansStore } from '@/store/usePlansStore';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';

export const useUserMenu = () => {
  const organizationStore = useOrganizationStore();
  const userStore = useUserStore();
  const plansStore = usePlansStore();
  const entitlementsStore = useEntitlementsStore();
  const { planCode } = storeToRefs(organizationStore);

  const menuItems = computed(() => {
    const name = userStore.name || userStore.email || '';
    const orgId = organizationStore.id;
    let menu: any[] = [];
    if (!orgId) return menu;

    const cfg = menuItemsConfig(orgId, name);

    const topMenu = [cfg.profileName, cfg.separator, cfg.myAccount, cfg.settings, cfg.separator];
    const manageTeamMenu = [cfg.workspaceMembers, cfg.inviteToTeam, cfg.referrals, cfg.separator];
    const inviteTeamMenu = [cfg.inviteToTeam, cfg.separator];
    const upgradeMenu = [cfg.upgrade];
    const plansMenu = [cfg.plans];
    const bottomMenu = [cfg.download, cfg.separator, cfg.contactSales, cfg.help, cfg.separator, cfg.signout];

    menu = menu.concat(topMenu);
    if (planCode?.value) {
      if (!plansStore.isPersonal(planCode.value) && userStore.isOrgUserAdmin) {
        menu = menu.concat(manageTeamMenu);
      } else if (entitlementsStore.hasCapability('invitations') && !userStore.isOrgUserViewOnly) {
        menu = menu.concat(inviteTeamMenu);
      }
    }

    if (organizationStore.free || organizationStore.trial) {
      menu = menu.concat(upgradeMenu);
    } else {
      menu = menu.concat(plansMenu);
    }

    return menu.concat(bottomMenu);
  });

  return { menuItems };
};
